export const getColor = (color: string): string => color.replace('0x', '#');
